import React from 'react';
import YoutubeBackground from 'react-youtube-background'
import {Link} from "react-router-dom";

const IntroTwo = () => {
    return (
            <YoutubeBackground
                videoId="eS9Qm4AOOBY"
                overlay="rgba(0,0,0,.4)"
                className="intro-section section bg-video"
            >
                <div className="container">
                    <div className="row row-cols-lg-1 row-cols-1">

                        <div className="col align-self-center">
                            <div className="intro-content-two text-center mt-xl-8 mt-lg-8 mt-md-8 mt-sm-8 mt-xs-8">
                                <h2 className="title">Projetando marcas e experiências incríveis </h2>
                                <div className="desc">
                                    <p>Somos uma empresa localizada no Brasil. Pensamos em estratégia, criamos design, 
                                        desenvolvemos digital e criamos movimento. Para encaminhar sua marca e negócio.</p>
                                </div>
                                <Link to={process.env.PUBLIC_URL + "/"} className="btn btn-primary btn-hover-secondary">Comece</Link>
                                <Link to={process.env.PUBLIC_URL + "/"} className="btn btn-outline-white btn-hover-primary"> Saber mais </Link>
                            </div>
                        </div>

                    </div>
                </div>
            </YoutubeBackground>
    )
}


export default IntroTwo;
